<template>
    <el-card>
        <el-row align="middle">
            <el-col :span="24">
                <ComHeaderMenu></ComHeaderMenu>
            </el-col>
        </el-row>
    </el-card>
</template>

<script setup lang="ts">
import ComHeaderMenu from "./header/ComHeaderMenu.vue"

</script>

<style scoped>
.header-button {
    padding-right: 10px;
}
</style>
